import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "order-list-container"
};
import { getHistoryOrders } from "@/api/order";
import OrderCard from "@/components/order/OrderCard.vue";
import { watch } from "vue";
import { ref, computed, onActivated } from "vue";
import { useOrderListStore } from "@/store/orderListStore";
import { cloneDeep } from "lodash-es";
import { getUrlParam } from "@/utils/urlUtil";
import { useRoute } from "vue-router";
import PoweredBy from "@/components/PoweredBy.vue";
import EmptyListPlaceholder from "@/components/EmptyListPlaceholder.vue";
import { useOrder } from "@/hooks/useOrder";
import { OrderStatusEnum } from "@/constant/order";
import { useRememberScroll } from "@/hooks/useRememberScroll";
import axios from "axios";
export default {
  __name: 'OrdersView',
  setup: function setup(__props) {
    var CancelToken = axios.CancelToken;
    var cancelRequest;
    var _useOrder = useOrder(),
      toOrderView = _useOrder.toOrderView;
    var orderListStore = useOrderListStore();
    var _useRememberScroll = useRememberScroll("order-list", "orderListScrollTop", "setOrderListScrollTop"),
      rememberScrollPos = _useRememberScroll.rememberScrollPos,
      setScrollPos = _useRememberScroll.setScrollPos;
    rememberScrollPos();
    var route = useRoute();
    var queryId = getUrlParam("id", window.location.hash);
    var queryCallback = getUrlParam("callback", window.location.hash);
    var pageSize = ref(10);
    var loading = ref(false);
    if (queryId && queryCallback) {
      var newQuery = cloneDeep(route.query);
      delete newQuery.id;
      delete newQuery.callback;
      var newQueryStr = Object.keys(newQuery).map(function (key) {
        return "".concat(key, "=").concat(encodeURIComponent(newQuery[key]));
      }).join("&");
      window.location.replace("".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search, "#/home/order?").concat(newQueryStr));
      window.location.assign("".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search, "#/order_detail?id=").concat(queryId, "&callback=").concat(queryCallback));
    }
    var tab = computed({
      get: function get() {
        return orderListStore.getTab;
      },
      set: function set(val) {
        orderListStore.setTab(val);
      }
    });
    var orders = computed({
      get: function get() {
        return orderListStore.getOrders;
      },
      set: function set(val) {
        orderListStore.setOrders(val);
      }
    });
    var pageNum = computed({
      get: function get() {
        return orderListStore.getPageNum;
      },
      set: function set(val) {
        orderListStore.setPageNum(val);
      }
    });
    var finished = computed({
      get: function get() {
        return orderListStore.getFinished;
      },
      set: function set(val) {
        orderListStore.setFinished(val);
      }
    });
    var statusFilterMap = {
      current: [OrderStatusEnum.TO_PAY, OrderStatusEnum.TO_ACCEPT, OrderStatusEnum.PREPARING, OrderStatusEnum.READY, OrderStatusEnum.OUT_OF_DELIVERY],
      history: [OrderStatusEnum.COMPLETED, OrderStatusEnum.CANCELLED, OrderStatusEnum.REJECT_CANCELLED, OrderStatusEnum.DELIVERING_CANCELLED, OrderStatusEnum.TO_DELIVER_CANCELLED, OrderStatusEnum.READY_CANCELLED, OrderStatusEnum.REFUNDED]
    };
    watch(tab, function () {
      handleCancelRequest();
      orderListStore.setOrders([]);
      pageNum.value = 1;
      finished.value = false;
      fetchData();
    });
    function handleCancelRequest() {
      var _cancelRequest;
      (_cancelRequest = cancelRequest) === null || _cancelRequest === void 0 || _cancelRequest();
      finished.value = true;
    }
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }
    function _fetchData() {
      _fetchData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.next = 3;
              return getHistoryOrders({
                order_status: statusFilterMap[tab.value],
                page_num: pageNum.value,
                page_size: pageSize.value
              }, new CancelToken(function executor(c) {
                cancelRequest = c;
              }));
            case 3:
              res = _context.sent;
              loading.value = false;
              if (res.isOK) {
                data = res.data.data || [];
                if (data.length > 0) {
                  orders.value = orders.value.concat(data);
                  pageNum.value += 1;
                } else {
                  finished.value = true;
                }
              } else {
                finished.value = true;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }
    var onInvoiceSuccess = function onInvoiceSuccess(orderId, data) {
      var arr = _toConsumableArray(orders.value);
      var targetOrder = arr.find(function (order) {
        return order.order_id === orderId;
      });
      console.log(targetOrder);
      if (targetOrder) {
        targetOrder.invoice_info = {
          id: data.invoice_record_id,
          status: "under_review"
        };
      }
      orders.value = arr;
    };
    onActivated(function () {
      if (orders.value.length) {
        setScrollPos();
      } else {
        fetchData();
      }
    });
    return function (_ctx, _cache) {
      var _component_van_tab = _resolveComponent("van-tab");
      var _component_van_tabs = _resolveComponent("van-tabs");
      var _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!loading.value && orders.value.length === 0 ? (_openBlock(), _createBlock(EmptyListPlaceholder, {
        key: 0,
        text: _ctx.$t('haveNoOrdersYet'),
        btntext: _ctx.$t('orderNow'),
        class: "empty",
        onGo: _unref(toOrderView)
      }, null, 8, ["text", "btntext", "onGo"])) : _createCommentVNode("", true), _createVNode(_component_van_tabs, {
        active: tab.value,
        "onUpdate:active": _cache[0] || (_cache[0] = function ($event) {
          return tab.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_tab, {
            title: _ctx.$t('currentOrder'),
            name: "current"
          }, null, 8, ["title"]), _createVNode(_component_van_tab, {
            title: _ctx.$t('orderHistroy'),
            name: "history"
          }, null, 8, ["title"])];
        }),
        _: 1
      }, 8, ["active"]), _createVNode(_component_van_list, {
        id: "order-list",
        loading: loading.value,
        "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) {
          return loading.value = $event;
        }),
        finished: finished.value,
        "loading-text": _ctx.$t('loading'),
        class: "item-list",
        onLoad: fetchData
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orders.value, function (order) {
            return _openBlock(), _createBlock(OrderCard, {
              key: order.order_id,
              item: order,
              onRefresh: onInvoiceSuccess
            }, null, 8, ["item"]);
          }), 128)), finished.value ? (_openBlock(), _createBlock(PoweredBy, {
            key: 0,
            "is-list": ""
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["loading", "finished", "loading-text"])]);
    };
  }
};